import type { Diagram, Entity, Boundary, EntityMap, BoundaryMap } from '@/types';

export function createEntityMap(diagram: Diagram): EntityMap {
  const map: EntityMap = {};
  diagram.entities.forEach((entity) => {
    map[entity.id] = entity;
  });
  return map;
}

export function createBoundaryMap(diagram: Diagram): BoundaryMap {
  const map: BoundaryMap = {};
  diagram.boundaries.forEach((boundary) => {
    map[boundary.id] = boundary;
  });
  return map;
}

export function getBoundaryChain(
  boundaryId: number | undefined | null,
  boundariesMap: BoundaryMap
): string | null {
  if (!boundaryId || !boundariesMap[boundaryId]) return null;

  const chain: string[] = [];
  let currentBoundary: Boundary | undefined = boundariesMap[boundaryId];

  while (currentBoundary) {
    chain.unshift(currentBoundary.name);
    currentBoundary = currentBoundary.parent_boundary_id
      ? boundariesMap[currentBoundary.parent_boundary_id]
      : undefined;
  }

  return chain.join(' > ');
}

export function getEntityById(id: number, entitiesMap: EntityMap): Entity | undefined {
  return entitiesMap[id];
}

export function getBoundaryById(id: number, boundariesMap: BoundaryMap): Boundary | undefined {
  return boundariesMap[id];
}

export interface DiagramStats {
  entityCount: number;
  pathCount: number;
  uniqueBoundaries: number;
  uniqueProtocols: number;
}

export function calculateDiagramStats(diagram: Diagram): DiagramStats {
  const uniqueBoundaryNames = new Set(diagram.boundaries.map((b) => b.name));
  const uniqueProtocols = new Set(diagram.paths.map((p) => p.protocol));

  return {
    entityCount: diagram.entities.length,
    pathCount: diagram.paths.length,
    uniqueBoundaries: uniqueBoundaryNames.size,
    uniqueProtocols: uniqueProtocols.size,
  };
}
